// Importing all constants to one file
import { SHOW_INTRO } from './intro';
import { USER_TOKEN } from './user';
import { LOGIN_DETAIL } from './logindetail';
import { USER_DETAIL } from './userdetails';
import { MESSAGE_DETAIL } from './MessageConst';
import { NEWS_DETAIL } from './NewsConst';
import { RESULT_CONSTANT } from './ResultConst';
import { LANGUAGE_DETAIL } from './LanguageDetails';
import { OPEN_DRAWER } from './drawer';

const GET_COINS = 'GET_COINS';
// Exporting alll constants
export {
  SHOW_INTRO,
  USER_TOKEN,
  LANGUAGE_DETAIL,
  LOGIN_DETAIL,
  USER_DETAIL,
  GET_COINS,
  MESSAGE_DETAIL,
  NEWS_DETAIL,
  RESULT_CONSTANT,
  OPEN_DRAWER
};
